import CONFIG from './config-backend.js';

document.addEventListener('DOMContentLoaded', async () => {
  document.getElementById('logoutbtn').addEventListener('click', logout);

  const token = localStorage.getItem('token');

  if (!token) {
    window.location.href = '/login';
    return;
  }

  const valid = await verifyToken(token);
  if (valid) {
    document.body.style.display = 'block';
  } else {
    localStorage.removeItem('token');
    window.location.href = '/login';
  }
});

async function verifyToken(token) {
  try {
    const response = await fetch(`${CONFIG.BACKEND_URL}/user/me`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    return response.ok;
  } catch {
    return false;
  }
}

async function logout() {
  const token = localStorage.getItem('token');

  if (token) {
    try {
      await fetch(`${CONFIG.BACKEND_URL}/user/logout`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error('Error on logout:', error);
    }
  }

  localStorage.removeItem('token');
  window.location.href = '/login';
}
